module.exports = __webpack_public_path__ + "static/onur-afsar-be888f0546fcf986385100c6d6603e7a.png";